var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"datas":_vm.datas,"nv-items":_vm.nvItems,"lang":_vm.lang,"page-name":"about-us"},on:{"homeClick":_vm.hClick}})}
var staticRenderFns = []

export { render, staticRenderFns }